module.exports = __webpack_public_path__ + "assets/media/day39.7837a326.mp3";